<!-- FreeNfcIcon.vue -->
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :viewBox="'0 0 64 64'"
    :width="size"
    :height="size"
    role="img"
    aria-label="Free NFC icon"
    :style="svgVars"
  >
    <!-- کارت -->
    <rect x="6" y="10" rx="4" ry="4" width="44" height="36" :fill="fill" />

    <!-- NFC waves -->
    <g transform="translate(34,16)">
      <path
        d="M18 6c0 6-9 12-9 12"
        fill="none"
        :stroke="accent"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M14 6c0 4-6 8-6 8"
        fill="none"
        :stroke="accent"
        stroke-width="1.6"
        stroke-linecap="round"
      />
      <circle cx="4" cy="6" r="1.3" :fill="accent" />
    </g>

    <!-- روبان "FREE" -->
    <g transform="translate(8,36)">
      <path d="M0 0 L34 0 L28 10 L0 10 Z" :fill="ribbon" />
      <text
        x="6"
        y="7.5"
        font-family="Arial, Helvetica, sans-serif"
        font-size="6"
        font-weight="700"
        :fill="textColor"
      >
        FREE
      </text>
    </g>

    <!-- برجستگی سطح کارت -->
    <rect x="8" y="12" rx="2" ry="2" width="20" height="10" :fill="overlay" />
  </svg>
</template>

<script>
export default {
  name: "FreeNfcIcon",
  props: {
    size: { type: [Number, String], default: 40 }, // px یا واحد
    fill: { type: String, default: "#0ea5a4" }, // رنگ اصلی کارت
    accent: { type: String, default: "#ffffff" }, // رنگ نماد NFC و متن روی روبان
    ribbon: { type: String, default: "#f59e0b" }, // رنگ روبان
    textColor: { type: String, default: "#ffffff" }, // رنگ متن روی روبان
    overlay: { type: String, default: "rgba(255,255,255,0.12)" }, // جلوه سطح
  },
  computed: {
    svgVars() {
      return {
        "--icon-fill": this.fill,
        "--icon-accent": this.accent,
        "--ribbon": this.ribbon,
      };
    },
  },
};
</script>
